module.exports = __webpack_public_path__ + "img/bienvenida.094b7f00.svg";